import { useEffect, useState } from "react";
import {
    CommonHeader,
    EmptyListPage,
    ErrorSuccessModal,
    TableLoader,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
    checkUniqueClientGroupNameAction,
    createMasterClientGroupAction,
    getMasterDataClientGroupAction,
    resetClientGroupList,
    resetClientGroupTotalCount,
    resetClientGroupUniqueCheckFetching,
    resetClientGroupUniqueCheckMessage,
    resetMasterError,
    resetMasterMessage,
    resetMasterStatusCode,
    resetMasterSuccess,
    updateMasterDataClientGroupAction,
} from "../../../redux/masterData";

import {
    CreateClientGroupDataPayloadType,
    GetClientGroupDataPayloadType,
    UniqueClientGroupNamePayloadType,
    UpdateClientGroupDataPayloadType,
} from "../../../commonTypes/masterDataTypes";

import { SearchIcon } from "../../../components/Icon";
import { EmptyList } from "../../../assets/images";
import useDebounce from "../../../customHooks/useDebounce";
import AddEditClientGroup from "./AddEditClientGroup";
import ClientGroupTable from "../../../components/MasterData/ClientGroupTable/ClientGroupTable";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type AppProps = {
    history: any;
    fetching: boolean;
    message: string;
    success: null | number;
    error: null | string;
    statusCode: null | number;
    isOpen: boolean;
    branchHeaders: [];
    token: null | string;
    clientGroupList: any;
    clientGroupTotalCount: number;
    clientGroupUniqueCheckMessage: string;
    uniqueClientFetching: boolean;
    dispatchResetMasterStatusCode: () => void;
    dispatchResetClientGroupUniqueCheckMessage: () => void;
    dispatchResetresetClientGroupUniqueCheckFetching: () => void;
    dispatchCheckUniqueClientGroupName: (data: UniqueClientGroupNamePayloadType) => void
    dispatchResetSession: () => void;
    dispatchResetMasterDataListing: () => void
    dispatchResetMasterDataBranchListTotal: () => void
    dispatchResetMasterSuccess: () => void;
    dispatchResetMasterMessage: () => void;
    dispatchResetMasterError: () => void;
    dispatchUpdateMasterDataClientGroup: (data: UpdateClientGroupDataPayloadType) => void;
    dispatchAddMasterClientGroupName: (data: CreateClientGroupDataPayloadType) => void;
    dispatchGetMasterDataClientGroup: (data: GetClientGroupDataPayloadType) => void;
};
const ClientGroupList = ({
    fetching,
    message,
    success,
    error,
    token,
    statusCode,
    dispatchResetMasterError,
    dispatchResetMasterDataListing,
    dispatchResetSession,
    dispatchResetMasterDataBranchListTotal,
    dispatchResetMasterSuccess,
    dispatchResetMasterMessage,
    dispatchResetMasterStatusCode,
    dispatchResetClientGroupUniqueCheckMessage,
    dispatchResetresetClientGroupUniqueCheckFetching,
    dispatchCheckUniqueClientGroupName,
    dispatchGetMasterDataClientGroup,
    dispatchUpdateMasterDataClientGroup,
    dispatchAddMasterClientGroupName,
    clientGroupList,
    clientGroupTotalCount,
    clientGroupUniqueCheckMessage,
    uniqueClientFetching
}: AppProps) => {
    const [showAddEditClientGroupModal, setShowAddEditClientGroupModal] = useState<boolean>(false);
    const [successMessage, setSuccessMessage] = useState<string>("");
    const [clientGroupNameError, setClientGroupNameError] = useState<string>("");
    const [clientGroupName, setClientGroupName] = useState<string>("");
    const [searchValue, setSearchValue] = useState("");
    const [data, setData] = useState<[] | any[]>([]);
    const [clearFilter, setClearFilter] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [id, setId] = useState<string | null | undefined>(null);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(20);

    //====================User Management=============================
    const [isClientGroupListPresent, setIsClientGroupListPresent] = useMenuCheck()
    const [isClientGroupAddButtonPresent, setIsClientGroupAddButtonPresent] = useMenuCheck()
    const [isClientGroupEditButtonPresent, setIsClientGroupEditButtonPresent] = useMenuCheck()
    //=================================================================
    useEffect(() => {
        dispatchResetMasterSuccess()
        dispatchResetMasterError()
        dispatchResetMasterMessage()
        dispatchResetMasterDataListing()
        dispatchResetMasterDataBranchListTotal()
        dispatchResetMasterStatusCode();
        dispatchResetClientGroupUniqueCheckMessage();
        dispatchResetresetClientGroupUniqueCheckFetching();
        setIsClientGroupListPresent("Client Group List", "menu")
        setIsClientGroupAddButtonPresent("Add Client Group", "menu")
        setIsClientGroupEditButtonPresent("Update Client Group", "menu")
    }, [])

    useEffect(() => {
        if (clientGroupList?.length === 0) {
            setData(clientGroupList);
        }
        if (offset > 0) {
            setData((prv: any) => [...prv, ...clientGroupList]);
        } else {
            setData(clientGroupList);
        }
    }, [clientGroupList]);

    useEffect(() => {
        if (token) {
            let finalData: GetClientGroupDataPayloadType = {
                token,
                limit,
                offset,
                searchValue,
            };
            if (clientGroupTotalCount) {
                if (offset < clientGroupTotalCount){
                    dispatchGetMasterDataClientGroup(finalData);
                }
            } else{
                dispatchGetMasterDataClientGroup(finalData);
            }
        }
    }, [offset]);

    useDebounce(
        () => {
            if (searchValue) {
                fetchNewData();
            }
            else{
                let finalData: GetClientGroupDataPayloadType = {
                    token,
                    limit,
                    offset,
                    searchValue,
                };
                dispatchGetMasterDataClientGroup(finalData);
            }
        },
        500,
        [searchValue]
    );

    useEffect(() => {
        if (!showAddEditClientGroupModal) {
            setIsEdit(false);
        }
    }, [showAddEditClientGroupModal]);

    const handleclientGroupNameChange = (e: any) => {
        setClientGroupName(e.target.value)
    };

    const toggleAddEditClientGroupModal = () => {
        if (!showAddEditClientGroupModal) {
            handleResetData();
        }
       
        setShowAddEditClientGroupModal(!showAddEditClientGroupModal);
    };


    const handleResetData = () => {
        setClientGroupName("");
        setOffset(0)
    };
    const fetchNewData = () => {
        dispatchResetMasterDataListing();
        if (token) {
            let finalData = {
                token,
                searchValue,
                limit,
                offset,
            };
            if (offset === 0) {
                dispatchGetMasterDataClientGroup(finalData);
            } else {
                setOffset(0);
            }
        }
    };

    const handleSearch = (e: any) => {
        let value = e.target.value;
        setSearchValue(value);

        if (value?.length === 0) {
            let finalData = {
                offset: 0,
                limit,
                token,
            };
            dispatchGetMasterDataClientGroup(finalData);
        }
    };

    const handleEditMasterClientGroup = (data: any) => {
        dispatchResetClientGroupUniqueCheckMessage();
        dispatchResetresetClientGroupUniqueCheckFetching();
        setIsEdit(true);
        setShowAddEditClientGroupModal(true);
        setClientGroupName(data?.client_group_name);
        setId(data?._id);
    };

    const handleAddClientGroupName = () => {
        setRefresh(!refresh);
        dispatchResetMasterDataListing();
        dispatchResetMasterStatusCode();
        dispatchResetClientGroupUniqueCheckMessage();
        dispatchResetresetClientGroupUniqueCheckFetching();
        if (clientGroupName?.trim()?.length > 0) {
            if (isEdit) {
                let updateData = {
                    token: token,
                    clientGroupName,
                    id,
                };
                setClearFilter(true)
                dispatchUpdateMasterDataClientGroup(updateData);
                handleSuccessMessage("update-master-client-group");
            } else {
                let finalAddData = {
                    token,
                    clientGroupName
                };
                dispatchAddMasterClientGroupName(finalAddData);
                setClearFilter(true)
                handleSuccessMessage("created-master-client-group");
                setSearchValue("")
            }
        }
        let finalData = {
            token,
            searchValue,
            limit,
            offset,
        };
        if (offset === 0) {
            dispatchGetMasterDataClientGroup(finalData);
        } else {
            setOffset(0);
        }
    };

    const handleSuccessMessage = (type: string) => {
        switch (type) {
            case "created-master-client-group":
                return setSuccessMessage("Client Group Name Added Successfully!");
            case "update-master-client-group":
                return setSuccessMessage("Client Group Name Updated Successfully!");
            default:
                return setSuccessMessage("");
        }
    };

    const onScroll = () => {
        if (!fetching) {
            const scrollTop = document.documentElement.scrollTop;
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = document.documentElement.clientHeight;

            if (offset < clientGroupTotalCount && !fetching && Math.ceil(75 / 100 * scrollHeight) <= scrollTop + clientHeight) {
                if (clientGroupList?.length > 0) {
                    if (!fetching && offset < clientGroupTotalCount) {
                        setOffset(offset + limit);
                    }
                }
            }
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [clientGroupList]);

    useDebounce(
        () => {
            if (clientGroupName?.trim() && token) {
                const finalData = {
                    token,
                    operation: isEdit ? "update" : "add",
                    uniqueCheck: "client_group_name",
                    name: clientGroupName?clientGroupName.trim():"",
                    dataId: isEdit ? id : ""
                }
                dispatchCheckUniqueClientGroupName(finalData);
            }
        },
        500,
        [clientGroupName]
    )

    const handleErrorModal = () => {
        if (success === 0) {
            if (statusCode === 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message="Session Expired. Please Login Again!"
                        buttonText="Logout"
                        onPress={() => dispatchResetSession()}
                        statusCode={statusCode}
                    />
                );
            } else if (!!error && statusCode !== 401) {
                return (
                    <ErrorSuccessModal
                        type="error"
                        isOpen={!!error}
                        title="Error"
                        message={error}
                        buttonText="OK"
                        onPress={() => {
                            dispatchResetMasterError();
                        }}
                    />
                );
            }
        }
        if (success === 1 && message?.includes("added successfully!")) {
            dispatchResetMasterDataListing();
            dispatchResetMasterSuccess();
            dispatchResetMasterMessage();
            toast.success(successMessage, {
                duration: 2000,
            });
        }
        if (success === 1 && message?.includes("updated successfully!")) {
            dispatchResetMasterDataListing();
            dispatchResetMasterSuccess();
            dispatchResetMasterMessage();
            toast.success(successMessage, {
                duration: 2000,
            });
           
        }

        return false;
    };

    useEffect(() => {
        if (offset === 0) {
            window.scrollTo(0, 0);
        } else {
            window.scrollTo(0, 0);
            setOffset(0);
        }
    }, [success]);


    return (
        <div className="row">
            <div className="col-md-6">
                <CommonHeader title="Client Group" />
            </div>
            <div className="col-md-12">
                <div className='jobs-card'>
                    <div className="header">
                        <div className="left-header">
                            <div className="heading">Client Group List</div>
                            {!fetching && isClientGroupListPresent && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${clientGroupTotalCount ? clientGroupTotalCount : 0} entries found`}</div>}
                        </div>
                        <div className='right-header'>
                            <div className={`${!!clientGroupList?.length? 'col-md-6':"col-md-10"} position-relative`} >
                                <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                                    <SearchIcon />
                                </span>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Search"
                                    onChange={(e) => handleSearch(e)}
                                    style={{ paddingLeft: "35px" }}
                                    value={searchValue}
                                />
                            </div>
                            {isClientGroupAddButtonPresent && !!clientGroupList?.length &&( <button className="btn btn-primary" onClick={toggleAddEditClientGroupModal}>
                                + Add Client Group
                            </button>)}
                        </div>
                    </div>
                    <div>
                        {fetching && offset == 0 ?
                            <TableLoader Rows={10} ColumnPerRow={7} />
                            : clientGroupList?.length > 0 && isClientGroupListPresent ? (
                                <ClientGroupTable
                                    data={data}
                                    handleEditMasterClientGroup={handleEditMasterClientGroup}
                                    isClientGroupEditButtonPresent={isClientGroupEditButtonPresent}
                                    fetching={fetching}
                                    offset={offset}
                                />
                            ) : <div className="mt-5 pb-5">
                                {!fetching && data?.length === 0 && <EmptyListPage
                                    title="No Client Group List Found!"
                                    image={EmptyList}
                                    imageWidth="30%"
                                    showAddButton={isClientGroupAddButtonPresent}
                                    buttonTitle="+ Add Client Group"
                                    onButtonClick={toggleAddEditClientGroupModal}
                                />}</div>
                        }
                    </div>
                </div>
            </div >
            {showAddEditClientGroupModal && <AddEditClientGroup
                showAddEditClientGroupModal={showAddEditClientGroupModal}
                toggleAddEditClientGroupModal={toggleAddEditClientGroupModal}
                isEdit={isEdit}
                uniqueClientFetching={uniqueClientFetching}
                clientGroupName={clientGroupName}
                clientGroupNameError={clientGroupNameError}
                clientGroupUniqueCheckMessage={clientGroupUniqueCheckMessage}
                handleAddClientGroupName={handleAddClientGroupName}
                handleclientGroupNameChange={handleclientGroupNameChange}
            />}
            {handleErrorModal()}
            <Toaster />
        </div >
    );
};

const mapStateToProps = (state: RootState) => ({
    token: state.auth.token,
    fetching: state.masterData.fetching,
    statusCode: state.masterData.statusCode,
    error: state.masterData.error,
    clientGroupList: state.masterData.clientGroupList,
    clientGroupTotalCount: state.masterData.clientGroupTotalCount,
    success: state.masterData.success,
    message: state.masterData.message,
    clientGroupUniqueCheckMessage: state.masterData.clientGroupUniqueCheckMessage,
    uniqueClientFetching: state.masterData.clientGroupUniqueCheckFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
    dispatchResetSession: () => dispatch(resetSession()),
    dispatchAddMasterClientGroupName: (data: CreateClientGroupDataPayloadType) =>
        dispatch(createMasterClientGroupAction(data)),
    dispatchGetMasterDataClientGroup: (data: GetClientGroupDataPayloadType) => {
        dispatch(getMasterDataClientGroupAction(data));
    },
    dispatchUpdateMasterDataClientGroup: (data: UpdateClientGroupDataPayloadType) => {
        dispatch(updateMasterDataClientGroupAction(data));
    },
    dispatchCheckUniqueClientGroupName: (data: UniqueClientGroupNamePayloadType) => dispatch(checkUniqueClientGroupNameAction(data)),
    dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
    dispatchResetMasterError: () => dispatch(resetMasterError()),
    dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
    dispatchResetMasterDataListing: () => dispatch(resetClientGroupList()),
    dispatchResetMasterDataBranchListTotal: () => dispatch(resetClientGroupTotalCount()),
    dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
    dispatchResetClientGroupUniqueCheckMessage: () => dispatch(resetClientGroupUniqueCheckMessage()),
    dispatchResetresetClientGroupUniqueCheckFetching: () => dispatch(resetClientGroupUniqueCheckFetching())
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientGroupList);
